module.exports = __webpack_public_path__ + "static/img/group-8@2x.0837240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-mini-guitar/group-8@2x.png
// module id = MLIT
// module chunks = 13